/** @jsx jsx */
import { Flex, Paragraph } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { formatFullName } from "@/data/persons";
import { RouteButton } from "@/infrastructure/Route";
import { router } from "@/views/router";

interface Props {
  firstName: string;
  lastName: string;
}

export const LoginOnBehalfBanner: FC<Props> = props => {
  const { t } = useTranslation("session");
  return (
    <Flex alignItems="center" justifyContent="center" flexWrap="wrap" sx={{ p: "sm", bg: "n1000" }}>
      <Paragraph color="n0" size="p-lg">
        {t("COMPONENTS.LOGIN_ON_BEHALF_BANNER.CONTENT")}
        <span sx={{ fontWeight: "bold" }}>{formatFullName(props)}</span>
      </Paragraph>
      <RouteButton sx={{ ml: "sm" }} size="lg" path={router.get("logout").path} testName="logout">
        {t("COMPONENTS.LOGIN_ON_BEHALF_BANNER.BUTTON_LOG_OUT")}
      </RouteButton>
    </Flex>
  );
};
